import React, { useEffect, useState } from 'react';
import { generateClassName } from '../b2b-common/helpers';

import './MarIaAnswer.css';

const MarIaAnswer = ({ answer = '', className = null }) => {

    const [processedAnswer, setProcessedAnswer] = useState('');

    useEffect(() => {
        //console.log('Processed Answer:', processedAnswer);
    }, [processedAnswer]);

    useEffect(() => {
        // Function to format the answer
        const formatAnswer = (text) => {
            // Ensure text is treated as a string
            const safeText = String(text);
            // Split the text by double newlines and join them with <br/><br/> for HTML paragraph breaks
            const splitParagraphs = safeText.split('\n\n').join('<br/><br/>');
            // Replace single newlines with <br/> for line breaks within paragraphs
            const singleLineBreaks = splitParagraphs.replace(/\n/g, '<br/>');
            // Adjust the regular expression to wrap words in **, including leading numbers and punctuation, with <strong> tags
            const boldWords = singleLineBreaks.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>');
            // Correctly format the list items by removing the asterisk and leading spaces
            const bulletPoints = boldWords.replace(/(?:<br\/>|^)\* (.+?)(?=<br\/>|$)/g, '<li>$1</li>');
            // Wrap sequences of <li> tags with <ul> tags to form unordered lists, ensuring proper HTML structure
            const lists = bulletPoints.replace(/(<li>.*?<\/li>)/g, (match) => {
                // Check if the match is already part of a list to avoid double wrapping
                if (!/<ul>.*<\/ul>/.test(match)) {
                    return `<ul>${match}</ul>`;
                }
                return match;
            });
            setProcessedAnswer(lists);
        };
        //console.log('Answer:', answer);
        formatAnswer(answer);
    }, [answer]);

    return (

        processedAnswer && processedAnswer.length > 0 && (
            <div className={generateClassName("maria-answer", "-container", className)}>
                <div dangerouslySetInnerHTML={{ __html: processedAnswer }} />
            </div>
        )

    );
};

export default MarIaAnswer;